import { render } from "./PdfGeneration.vue?vue&type=template&id=4903023e&scoped=true"
import script from "./PdfGeneration.vue?vue&type=script&lang=js"
export * from "./PdfGeneration.vue?vue&type=script&lang=js"

import "./PdfGeneration.vue?vue&type=style&index=0&id=4903023e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4903023e"]])

export default __exports__